export const TQR_CODE_CONFIG = {
  DURATION: 30,
  ROTATION_INTERVAL_DURATION: 0.25,
  TIME_TOLERANCE: 30,
  SIZE: 260,
}

export default null
